/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Warning_Trunk_TiltedInputs */

const en_us2_body_assessment_warning_trunk_tilted = /** @type {(inputs: Body_Assessment_Warning_Trunk_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trunk was slightly tilted, so the estimate may be shifted. Next time, stand up straight.`)
};

const pt_br2_body_assessment_warning_trunk_tilted = /** @type {(inputs: Body_Assessment_Warning_Trunk_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tronco ficou levemente inclinado, então a estimativa pode estar deslocada. Na próxima vez, fique em pé e reto.`)
};

const es_419_body_assessment_warning_trunk_tilted = /** @type {(inputs: Body_Assessment_Warning_Trunk_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu tronco estaba un poco inclinado, así que la estimación puede estar desviada. La próxima vez, ponte de pie con el cuerpo recto.`)
};

const pt_pt2_body_assessment_warning_trunk_tilted = /** @type {(inputs: Body_Assessment_Warning_Trunk_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tronco ficou ligeiramente inclinado, por isso a estimativa pode estar desviada. Da próxima vez, fica de pé e direito.`)
};

const fr_fr2_body_assessment_warning_trunk_tilted = /** @type {(inputs: Body_Assessment_Warning_Trunk_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton tronc était légèrement penché, l'estimation est peut-être décalée. La prochaine fois, tiens-toi bien droit.`)
};

const de_de2_body_assessment_warning_trunk_tilted = /** @type {(inputs: Body_Assessment_Warning_Trunk_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Rumpf war leicht geneigt, daher kann die Schätzung verschoben sein. Steh nächstes Mal aufrecht.`)
};

const it_it2_body_assessment_warning_trunk_tilted = /** @type {(inputs: Body_Assessment_Warning_Trunk_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tronco era leggermente inclinato, quindi la stima potrebbe essere spostata. La prossima volta, stai dritto.`)
};

/**
* | output |
* | --- |
* | "Your trunk was slightly tilted, so the estimate may be shifted. Next time, stand up straight." |
*
* @param {Body_Assessment_Warning_Trunk_TiltedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_trunk_tilted = /** @type {((inputs?: Body_Assessment_Warning_Trunk_TiltedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_Trunk_TiltedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_trunk_tilted(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_trunk_tilted(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_trunk_tilted(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_trunk_tilted(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_trunk_tilted(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_trunk_tilted(inputs)
	return en_us2_body_assessment_warning_trunk_tilted(inputs)
});
export { body_assessment_warning_trunk_tilted as "body-assessment.warning.trunk_tilted" }